import getGraphQlClient from '~graphql/getGraphQlClient';
import { UPDATE_DISABLED_USER_FEATURE } from '~graphql/queries/features';
import { onErrorShowMessage } from '~src/errors';

/**
 * Update a Features_preference record by id.
 * @param {Object} options
 * @param {string} options.id - Features_preference objectId
 * @param {boolean} options.disabled - New disabled value
 * @param {string} [options.style] - Optional style
 * @returns {Promise<Object>} Updated features_preference
 */
export const updateFeaturePreference = async ({ id, disabled, style }) => {
  try {
    const client = await getGraphQlClient();

    const variables = {
      id,
      fields: {
        disabled,
        ...(typeof style !== 'undefined' ? { style } : {}),
      },
    };

    const { data } = await client.mutate({
      mutation: UPDATE_DISABLED_USER_FEATURE,
      variables,
    });

    return data?.updateFeatures_preference?.features_preference;
  } catch (error) {
    console.error('updateFeaturePreference error', error);
    await onErrorShowMessage(false);
    throw error;
  }
};
